// src/directives/clickOutside.js
export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      // If click is not inside this element
      // AND not on the trigger (.border-contribution), then close
      if (
        !(el === event.target || el.contains(event.target)) &&
        !event.target.closest(".border-contribution-small") &&
        !event.target.closest(".border-contribution")
      ) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  },
};
